import React from 'react'
import { Menu, MenuItem } from '@blueprintjs/core'
import { TaskT, TaskActionTypeT } from 'ui-io/task-io/task-t'
import copy from 'copy-to-clipboard'
import useSession from 'ui-io/use-session'

import toasts from '../../../utils/toasts'

type ArrayElement<A> = A extends readonly (infer T)[] ? T : never
export const TASK_CONTEXT_MENU_ITEMS = [
  'splunkLink',
  'permaLink',
  'goToConfiguration',
  'json',
  'archiveUrl',
] as const
export type ContextMenuItem = ArrayElement<typeof TASK_CONTEXT_MENU_ITEMS>

const TaskRowContextMenu = ({
  task,
  contextMenuItems,
  onShowJson,
  setTaskAction,
}: {
  task: TaskT
  contextMenuItems?: ContextMenuItem[]
  onShowJson?: () => void
  setTaskAction: (actionType: TaskActionTypeT) => void
}) => {
  const handleOnCopy = (text: string) => {
    copy(text)
    toasts.success('Copied to clipboard!')
  }
  const { session } = useSession()
  const username = session?.username

  return (
    <Menu>
      <MenuItem
        text="Show JSON"
        icon="search-around"
        disabled={
          (contextMenuItems && !contextMenuItems.includes('json')) ||
          !onShowJson
        }
        onClick={onShowJson}
      />
      <MenuItem
        text="Copy Task ID"
        icon="clipboard"
        onClick={() => handleOnCopy(task.id)}
      />
      <MenuItem
        text="Copy Company ID"
        icon="clipboard"
        onClick={() => task._raw?.companyID && handleOnCopy(task._raw.companyID)}
      />
      {task.isReassignable && (
        <MenuItem
          text="Reassign"
          icon="following"
          onClick={() => {
            setTaskAction('REASSIGN')
          }}
        />
      )}
      {username && task.assignee === username && (
        <MenuItem
          text="Unassign"
          icon="undo"
          onClick={() => {
            setTaskAction('UNASSIGN')
          }}
        />
      )}
      {task.isSelfAssignable && (
        <MenuItem
          text="Self Assign"
          icon="following"
          onClick={() => {
            setTaskAction('SELF_ASSIGN')
          }}
        />
      )}
      {!!task.assignee && (
        <MenuItem
          text="Edit Task"
          icon="edit"
          onClick={() => {
            setTaskAction('EDIT')
          }}
        />
      )}
    </Menu>
  )
}

export default TaskRowContextMenu
